import { useState, useEffect } from 'react';
import { compose } from 'react-recompose';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Tooltip, Button, Pagination, Switch } from 'antd';
import { Edit, Delete, RemoveRedEye } from '@material-ui/icons';
import DeleteConfirmModal from 'components/Basic/DeleteConfirmModal';
import ShippingCostViewModal from './ShippingCostViewModal';
import { getMealType } from 'utilities/transformDateTime';

function ShippingCostTable({ intl, ShippingCostData, total, onChangePage, onDeleteShippingCost, onIsAvailable }) {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isRemoveModal, setIsRemoveModal] = useState(false);
  const [isShowViewModal, setShowViewModal] = useState(false);

  const [shippingCostInfo, setShippingCostInfo] = useState(null);

  const history = useHistory();

  useEffect(() => {
    onChangePage(0, 10);
  }, []);

  const handleChangePage = (page, size) => {
    setCurrent(page);
    setPageSize(size);
    onChangePage((page - 1) * size, size);
  };

  const handleShowSizeChange = (c, s) => {
    handleChangePage(1, s);
  };

  const handleDeleteShippingCost = async () => {
    setIsRemoveModal(false);
    onDeleteShippingCost(shippingCostInfo);
  };

  const handleShowShippingCost = async item => {
    setShippingCostInfo(item);
    setShowViewModal(true);
  };

  const handleIsAvailable = async (value, id) => {
    onIsAvailable(value, id);
  };

  const handleEditShippingCost = async item => {
    history.push(`/dashboard/shippingcost/${item.id}`);
  };

  const typeToTranslate = type => {
    let split = type.split('-');
    return split.map(part => intl.formatMessage({ id: part })).join(' - ');
  };

  return (
    <div className="shippingCost_table_layout">
      <div className="table_header">
        <div className="id">
          <FormattedMessage id="ID" />
        </div>
        <div className="type">
          <FormattedMessage id="Part time" />
        </div>
        <div className="isShippingCost">
          <FormattedMessage id="Enable / Disable" />
        </div>
        <div className="timesheet">
          <FormattedMessage id="timesheet" />
        </div>
        <div className="actions">
          <FormattedMessage id="actions" />
        </div>
      </div>
      <div className="table_content">
        {ShippingCostData &&
          ShippingCostData.map((item, index) => (
            <div className={`table_item state_${item.isAvailable}`} key={index}>
              <div className="id">
                <p className="title">{item.id}</p>
              </div>
              <div className="type">
                <p className="title">{typeToTranslate(getMealType(item.openTime, item.closeTime))}</p>
              </div>
              <div className="isShippingCost">
                <Switch checked={item.isAvailable ?? false} onChange={e => handleIsAvailable(e, item.id)} />
              </div>
              <div className="timesheet">
                <p className="title">
                  {item.openTime}-{item.closeTime}
                </p>
              </div>
              <div className="actions">
                <Tooltip placement="top" title={intl.formatMessage({ id: 'Show detail shipping cost' })}>
                  <Button
                    className="show_btn"
                    onClick={() => {
                      handleShowShippingCost(item);
                    }}
                  >
                    <RemoveRedEye />
                  </Button>
                </Tooltip>
                <Tooltip placement="top" title={intl.formatMessage({ id: 'Edit shipping cost' })}>
                  <Button className="edit_btn" onClick={() => handleEditShippingCost(item)}>
                    <Edit />
                  </Button>
                </Tooltip>
                <Tooltip placement="top" title={intl.formatMessage({ id: 'Delete shipping cost' })}>
                  <Button
                    className="delete_btn"
                    onClick={() => {
                      setIsRemoveModal(true);
                      setShippingCostInfo(item);
                    }}
                  >
                    <Delete />
                  </Button>
                </Tooltip>
              </div>
            </div>
          ))}
      </div>
      <div className="pagination_wrapper">
        <Pagination
          showSizeChanger
          defaultCurrent={1}
          defaultPageSize={10}
          current={current}
          pageSize={pageSize}
          pageSizeOptions={['5', '10', '20', '30']}
          total={total}
          onChange={handleChangePage}
          onShowSizeChange={handleShowSizeChange}
        />
        <div className="total">
          {intl.formatMessage({ id: 'Results' })}: {total}
        </div>
      </div>
      <ShippingCostViewModal
        isOpenModal={isShowViewModal}
        shippingCostInfo={shippingCostInfo}
        onCloseModal={() => setShowViewModal(false)}
      />
      <DeleteConfirmModal
        isOpenModal={isRemoveModal}
        title={intl.formatMessage({ id: 'Do you want to delete the shipping cost?' })}
        subtitle={intl.formatMessage({
          id: 'This action cannot be undone. Continue deleting shipping cost?',
        })}
        onCancel={() => setIsRemoveModal(false)}
        onOk={handleDeleteShippingCost}
      />
    </div>
  );
}

ShippingCostTable.defaultProps = {
  isShowEditModal: false,
};

export default compose(injectIntl)(ShippingCostTable);
